import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconAddTeams: React.FC<SvgIconProps> = (props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{
      color: COLORS.CERULEAN,
    }}
    {...props}
  >
    <path 
        d="M15.89 14.94C15.92 14.99 15.94 15.05 15.97 15.1C16.8 14.3 17.92 13.81 19.16 13.81C19.34 13.81 19.52 13.82 19.7 13.84C18.74 12.91 17.38 12.28 15.87 12.28C15.19 12.28 14.54 12.4 13.95 12.63C14.72 13.27 15.38 14.04 15.9 14.93L15.89 14.94Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M15.86 11.27C17.18 11.27 18.26 10.2 18.26 8.87C18.26 7.54 17.19 6.47 15.86 6.47C14.53 6.47 13.46 7.54 13.46 8.87C13.46 10.2 14.53 11.27 15.86 11.27Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M9.46 10.7C10.63 10.26 11.47 9.14 11.47 7.81C11.47 6.1 10.09 4.72 8.38 4.72C6.67 4.72 5.3 6.11 5.3 7.81C5.3 9.13 6.14 10.26 7.31 10.7C7.65 10.82 8.01 10.9 8.39 10.9C8.77 10.9 9.13 10.82 9.47 10.7H9.46ZM6.58 7.81C6.58 6.82 7.39 6.01 8.38 6.01C9.37 6.01 10.18 6.82 10.18 7.81C10.18 8.8 9.37 9.61 8.38 9.61C7.39 9.61 6.58 8.8 6.58 7.81Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M14.51 15.73C13.36 13.74 11.08 12.21 8.39 12.21C5.7 12.21 3.41 13.74 2.26 15.73C1.54 16.98 2.43 18.55 3.88 18.55H12.9C14.35 18.55 15.24 16.99 14.52 15.73H14.51ZM3.48 16.92C3.43 16.83 3.36 16.64 3.48 16.43C4.46 14.72 6.39 13.62 8.39 13.62C10.39 13.62 12.32 14.72 13.3 16.43C13.42 16.65 13.36 16.83 13.3 16.92C13.24 17.02 13.12 17.15 12.9 17.15H3.88C3.66 17.15 3.54 17.03 3.48 16.92Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M19.28 14.83C17.25 14.83 15.6 16.48 15.6 18.51C15.6 20.54 17.25 22.19 19.28 22.19C21.31 22.19 22.96 20.54 22.96 18.51C22.96 16.48 21.31 14.83 19.28 14.83ZM19.28 21.27C17.76 21.27 16.53 20.03 16.53 18.52C16.53 17.01 17.77 15.77 19.28 15.77C20.79 15.77 22.03 17.01 22.03 18.52C22.03 20.03 20.79 21.27 19.28 21.27Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M20.54 18.09H19.71V17.26C19.71 17.02 19.52 16.83 19.28 16.83C19.04 16.83 18.85 17.02 18.85 17.26V18.09H18.03C17.79 18.09 17.6 18.28 17.6 18.52C17.6 18.76 17.79 18.95 18.03 18.95H18.85V19.77C18.85 20.01 19.04 20.2 19.28 20.2C19.52 20.2 19.71 20.01 19.71 19.77V18.95H20.54C20.78 18.95 20.97 18.76 20.97 18.52C20.97 18.28 20.78 18.09 20.54 18.09Z" 
        stroke="none"
        fill="currentColor"
    />
  </SvgIcon>
)